import { render, staticRenderFns } from "./observed_7.vue?vue&type=template&id=25138884&scoped=true&"
var script = {}
import style0 from "./observed_7.vue?vue&type=style&index=0&id=25138884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25138884",
  null
  
)

export default component.exports